// extracted by mini-css-extract-plugin
export default {"SocialMediaContainer":"SocialMedia_SocialMediaContainer__uA2Dv"};